import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import StartCard from "../gpap-lib/StartCard/StartCard";
import { submission_cards_config } from "../gpap-lib/StartCard/card_config";

import auth from "./Auth";

export default function submissionSelection() {
  
  const [initialized, setInitialized] = useState(false);
  const [submissionCards, setSubmissionCards] = useState([]);

  const getSubmissionCards = (kcGroups) => {
    
    if (kcGroups.includes("admin")) {
      setSubmissionCards(submission_cards_config);
    } else {
      setSubmissionCards(submission_cards_config.slice(1));
    }
  };

  useEffect(() => {
    if (!initialized) {
      getSubmissionCards(auth.getUserGroups());
    }
    setInitialized(true);
  },[]);

  if (auth.tokenExpired()) {
    return (
      <div>Session expired. Please login again</div>
    )
  }

  return (
    <div className="home">
      <h2 id="home_header">Create new datasets und upload your files</h2>
      <hr className="divider" />
      <div className="ctas">
        <div className="container">
          <Grid container justify="center" spacing={2}>
            {initialized ? (
              submissionCards.map((card, index) => (
                <Grid key={`${card}-${index}`} item lg={4}>
                  <StartCard item={submissionCards[index]} />
                </Grid>
              ))) : (
                <div>Loading...</div>
              )
            }
          </Grid>
        </div>
      </div>
    </div>
  );
}
